import { SelectHTMLAttributes } from "react";
import { siteTexts } from "../i18n/siteTexts";
import AppSelect from "./AppSelect";

export const PLAYER_SEX_OPTIONS = [
  { value: "female", label: siteTexts.common.sex.female },
  { value: "male", label: siteTexts.common.sex.male },
];

type PlayerSexSelectProps = Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  "children"
> & {
  allLabel?: string;
  allValue?: string;
  includeAll?: boolean;
  includeOther?: boolean;
};

export function playerSexLabelFromCode(code?: string | null) {
  if (code === "other") return siteTexts.common.sex.other;
  return PLAYER_SEX_OPTIONS.find((option) => option.value === code)?.label || "";
}

export default function PlayerSexSelect({
  allLabel = siteTexts.common.filters.allSexes,
  allValue = "",
  includeAll = false,
  includeOther = false,
  ...props
}: PlayerSexSelectProps) {
  return (
    <AppSelect {...props}>
      {includeAll && <option value={allValue}>{allLabel}</option>}
      {PLAYER_SEX_OPTIONS.map((option) => (
        <option key={`player-sex-${option.value}`} value={option.value}>
          {option.label}
        </option>
      ))}
      {includeOther && (
        <option value="other">{siteTexts.common.sex.other}</option>
      )}
    </AppSelect>
  );
}
